/**
 * ByteStatistics - Statistics Card for Keyword Byte Counter
 */

import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/v2/ui';

interface ByteStatisticsProps {
  byteCount: number;
  charCount: number;
}

export function ByteStatistics({ byteCount, charCount }: ByteStatisticsProps) {
  const { t } = useTranslation();
  return (
    <Card className="rounded-xl shadow-sm border-neutral-200 dark:border-neutral-800">
      <CardContent className="p-6 space-y-4">
        <h3 className="text-sm font-semibold text-neutral-700 dark:text-neutral-200">
          {t('keywordByteCounter.statistics')}
        </h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-neutral-600 dark:text-neutral-400">{t('keywordByteCounter.bytesLabel')}</span>
            <span className="text-lg font-bold text-neutral-900 dark:text-neutral-100">
              {t('keywordByteCounter.bytesValue', { count: byteCount })}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-neutral-600 dark:text-neutral-400">{t('keywordByteCounter.charsLabel')}</span>
            <span className="text-lg font-bold text-neutral-900 dark:text-neutral-100">
              {charCount}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-neutral-600 dark:text-neutral-400">{t('keywordByteCounter.remaining')}</span>
            <span className={`text-lg font-bold ${byteCount > 250 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
              {t('keywordByteCounter.remainingBytes', { count: 250 - byteCount })}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
